import React, { useState, useEffect, useRef, useContext } from "react";
import { useOutletContext } from "react-router-dom";
import "./UserDetails.css";
import { useNavigate, useLocation, Outlet } from "react-router-dom";
import SearchField from "../SearchField/SearchField";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import SocketContext from "../../contexts/SocketContext";

const UserDetails = () => {
  // General States
  const axiosPrivate = useAxiosPrivate(null);
  const navigate = useNavigate();
  const location = useLocation();

  // Socket
  const { socket } = useContext(SocketContext);

  // Import Outlet Context Properties
  const [showUserDetails, selectedUser, setSelectedUser, setReloaddata, reloaddata, setShowsuccess, setSuccessMSG] =
    useOutletContext();

  // User Edits
  const [userEdits, setUserEdits] = useState(selectedUser ? selectedUser : {});
  const [editingUser, setEditingUser] = useState(false);

  // Handle Input Change
  const handleInputChange = (e) => {
    setEditingUser(true);
    setUserEdits({ ...userEdits, [e.target.name]: e.target.value });
  };

  // Handle Role Select
  const handleRoleSelect = (item) => {
    setUserEdits({ ...userEdits, ["role"]: item.role, ["roleID"]: item.roleID });
    setEditingUser(true);
  };

  // Cleanup
  const [toggleClearSF, setToggleClearSF] = useState(false);

  // Set selected user on change of selected user
  useEffect(() => {
    setUserEdits(selectedUser);
    setEditingUser(false);
    setToggleClearSF(!toggleClearSF);
  }, [selectedUser]);

  // Save user edits
  const saveUserEdits = async () => {
    try {
      const response = await axiosPrivate.post("/api/users/updateuser", {
        userEdits,
      });
      if (response.data.msg === "Saved") {
        setReloaddata(!reloaddata);
        setShowsuccess((prev) => !prev);
        setSuccessMSG("Edits saved successfully.");
        setEditingUser(false);
        await socket.emit("updateuser", userEdits);
      }
    } catch (err) {
      navigate("/login", { state: { from: location }, replace: true });
    }
  };

  return (
    <div className='userDetails'>
      {showUserDetails && (
        <>
          <h1>{selectedUser.name + " " + selectedUser.lastname}</h1>
          <h2>Edit User:</h2>
          <form
            className='edituser'
            onSubmit={(e) => {
              e.preventDefault();
              saveUserEdits();
            }}
          >
            <div className='form-item'>
              <label>User ID:</label>
              <input readOnly style={{ background: "var(--gray)" }} value={userEdits?.userID} />
            </div>
            <div className='form-item'>
              <label>User Code:</label>
              <input
                required
                name='userCode'
                autoComplete='off'
                onChange={(e) => handleInputChange(e)}
                value={userEdits?.userCode}
              />
            </div>
            <div className='form-item'>
              <label>Name:</label>
              <input
                required
                name='name'
                autoComplete='off'
                onChange={(e) => handleInputChange(e)}
                value={userEdits?.name}
              />
            </div>
            <div className='form-item'>
              <label>Lastname:</label>
              <input
                required
                name='lastname'
                autoComplete='off'
                onChange={(e) => handleInputChange(e)}
                value={userEdits?.lastname}
              />
            </div>
            <div className='form-item'>
              <label>User:</label>
              <input
                required
                name='user'
                autoComplete='off'
                onChange={(e) => handleInputChange(e)}
                value={userEdits?.user}
              />
            </div>
            <div className='form-item'>
              <label>Role:</label>
              <SearchField
                required={true}
                searchURL='/api/roles/getroles'
                value={userEdits?.role}
                valueName='role'
                valueID='roleID'
                style={{ width: "94%" }}
                onItemSelect={handleRoleSelect}
                clearfield={toggleClearSF}
              />
            </div>
            <div className='form-item'>
              <label>Active:</label>
              <select
                onChange={(e) => {
                  setUserEdits({ ...userEdits, ["active"]: e.target.value });
                  setEditingUser(true);
                }}
              >
                {userEdits.active === "y" ? (
                  <>
                    <option selected={true} value='y'>
                      Yes
                    </option>

                    <option value='n'>No </option>
                  </>
                ) : (
                  <>
                    <option value='y'>Yes</option>

                    <option selected={true} value='n'>
                      No{" "}
                    </option>
                  </>
                )}
              </select>
            </div>
            <div className='form-item'>
              <label>First Login:</label>
              <select
                onChange={(e) => {
                  setUserEdits({ ...userEdits, ["firstLogin"]: e.target.value });
                  setEditingUser(true);
                }}
              >
                {userEdits.firstLogin === "y" ? (
                  <>
                    <option selected={true} value='y'>
                      Yes
                    </option>

                    <option value='n'>No </option>
                  </>
                ) : (
                  <>
                    <option value='y'>Yes</option>

                    <option selected={true} value='n'>
                      No{" "}
                    </option>
                  </>
                )}
              </select>
            </div>
            <div className='form-buttons'>
              <button
                type='button'
                onClick={(e) => {
                  navigate("/admin/users", { state: { from: location }, replace: true });
                  setSelectedUser({});
                  setToggleClearSF(!toggleClearSF);
                }}
              >
                Cancel
              </button>
              <button type='submit' className={editingUser ? "mainbutton" : "disabledbutton"} disabled={!editingUser}>
                Save Edits
              </button>
            </div>
          </form>
        </>
      )}
    </div>
  );
};

export default UserDetails;
